import axios from "axios";
import { API_URL } from "../Config";
import authHeader from "./auth-header";

const list = (values) => {
  return axios.get(API_URL + "users", {
    headers: authHeader(),
    params: values,
  });
};
const create = (values) => {
  return axios.post(API_URL + "users/create", values, {
    headers: authHeader(),
  });
};
const update = (values) => {
  return axios.post(API_URL + "users/update", values, {
    headers: authHeader(),
  });
};
const destroy = (values) => {
  return axios.post(API_URL + "users/destroy", values, {
    headers: authHeader(),
  });
};

const usersService = { list, create, update, destroy };

export default usersService;
